interface Message {
	text?: string
	voiceId?: string
}

interface RegisterInputResponse {
	inputResponseType?: string
	interactionResultType?: string
	messages?: Message[]
}

const RegisterInputResponseInputResponseTypeEnum = {
	SystemHangup: 'SYSTEM_HANGUP',
	VoiceRedirect: 'VOICE_REDIRECT'
} as const

export function joinRegisterInputMessages(messages: Message[] | undefined): string {
	if (!messages || messages.length === 0) {
		return ''
	}
	return messages.map((message) => message.text || '').join(' ')
}

export const getModifiedRegisterInputResponseMessage: (
	response: RegisterInputResponse
) => string = (response: RegisterInputResponse): string => {
	const responseType = response.inputResponseType ?? response.interactionResultType
	if (
		responseType === RegisterInputResponseInputResponseTypeEnum.SystemHangup ||
		responseType === RegisterInputResponseInputResponseTypeEnum.VoiceRedirect
	) {
		return `${joinRegisterInputMessages(response.messages)}\n\n{${responseType}}`
	} else return joinRegisterInputMessages(response.messages)
}
